<template>
    <div>
        <input :accept="accepted" @change="fileChange" class="file-input" ref="fileInput" type="file" />
        <template v-if="!uploadInProgress">
            <v-btn depressed @click="uploadClick" icon v-if="fileData.name == '' && !readonly">
                <v-icon small>fa-upload</v-icon>
            </v-btn>
            <v-btn depressed @click="downloadClick" icon v-if="fileData.name != '' && !readonly">
                <v-icon small>fa-download</v-icon>
            </v-btn>
            <v-btn depressed @click="deleteClick" icon v-if="fileData.name != '' && !readonly">
                <v-icon small>fa-trash</v-icon>
            </v-btn>
        </template>
        <div v-if="uploadInProgress">
            {{ $t('labels.uploadInProgress') }}
        </div>
        <div class="pa-2" v-show="fileData.link">
            <div class="image-container">
                <img class="image" @click="imageClicked()" style="max-width: 1000%" :src="fileData.link" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.file-input {
    display: none;
}

/* .image-container {
    max-width: 300vw;
} */
.image {
    height: 370px;
}
</style>

<script>
export default {
    name: 'UploadImage',
    props: ['value', 'accept', 'readonly'],
    components: {},
    data() {
        return {
            fileData: {
                name: '',
                link: '',
                original_name: '',
                x: 0,
                y: 0,
                w: 0,
                h: 0,
                upload_id: null,
            },
            uploadInProgress: false,
            accepted: '',
        };
    },
    watch: {
        value: function () {
            this.fileData = this.$props.value;
        },
    },
    methods: {
        imageClicked() {
            this.$emit('click');
        },
        uploadClick() {
            this.$refs.fileInput.click();
        },
        fileChange() {
            this.uploadInProgress = true;
            var vm = this;
            this.$APIUpload(this.$refs.fileInput.files[0], (data) => {
                if (data['success']) {
                    vm.fileData = data['file'];
                    vm.uploadInProgress = false;
                    vm.$emit('input', vm.fileData);
                }
            });
        },
        downloadClick() {
            window.open(this.fileData.link);
        },
        deleteClick() {
            var vm = this;
            this.$verify(this.$t('alerts.fileDeletionQuestion'), (result) => {
                if (result) {
                    vm.fileData = {
                        name: '',
                        link: '',
                        original_name: '',
                        x: 0,
                        y: 0,
                        w: 0,
                        h: 0,
                        upload_id: null,
                    };
                    vm.$emit('input', vm.fileData);
                }
            });
        },
        cropImage() {},
    },
    mounted() {
        if (this.accept !== undefined) {
            this.accepted = this.accept;
        }
        this.fileData = this.$props.value;
    },
};
</script>
